module.exports = __webpack_public_path__ + "img/unclogo.a9cebb2c.png";